import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {Dropdown} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16, QUESTION__24} from '@homeaway/svg-defs';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Help.less';

function Help({items, label}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);

    function handleHelpMenuClick(item) {
        return () => {
            const eventFields = {
                actionlocation: `header.${item.text.replace(/\s/g, '').toLowerCase()}`
            };
            context.trigger('header.link.click', eventFields);

            return true;
        };
    }

    function handleHelpClick() {
        const eventFields = {
            actionlocation: 'header.help'
        };
        context.trigger('header.link.click', eventFields);
    }

    // if there are no links then render nothing
    if (!items) {
        return null;
    }

    const id = 'site-header__help';

    // Render items
    const toggle = (
        <button
            aria-expanded="false"
            aria-haspopup="true"
            className="site-header-nav__toggle Dropdown__toggle"
            id={id}
        >
            <SVGIcon inlineFlex markup={QUESTION__24}/>
            <span className="site-header-nav__icon-label">{label}</span>
            <SVGIcon className="Dropdown__toggle-icon" inlineFlex markup={CHEVRON_DOWN__16}/>
        </button>
    );

    const renderItem = (item, index) => {
        return (
            <li key={index} role="presentation">
                <a
                    className={item.cssClass}
                    data-bypass="true"
                    href={item.link}
                    onClick={handleHelpMenuClick(item)}
                    role="menuitem"
                >
                    {item.text}
                </a>
            </li>
        );
    };

    return (
        <Dropdown
            className="site-header-nav__dropdown site-header-help"
            customToggle={toggle}
            dropdownRight
            id={id}
            label={label}
            onDropdownShow={handleHelpClick}
        >
            {items.map(renderItem)}
        </Dropdown>
    );
}

Help.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    })),
    label: PropTypes.string.isRequired
};

export {Help};

